import { object, string } from 'valibot'
import { commonSchema } from '~/utils/solr/common'

/**
 * Schema for book footnote documents in Solr
 */
export const bookFootnoteSchema = object({
  ...commonSchema.entries,
  bodytext: string(),
  footnoteId: string(),
})
